import React from "react";

const AboutUs = () => {
  return (
    <section className="px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center mt-4">About Us</h1><br></br>

        <p className="mb-4">
          <strong>Bhatt & Karle Associates</strong> is a trusted name in Labour Law Consultancy,
          established with a vision to extend expert Regulatory Compliance services to industries
          across Pan-India. Headquartered in Mumbai, we have earned a strong reputation as a
          professional and reliable consultancy firm.
        </p>

        <p className="mb-4">
          Backed by a team of seasoned professionals, we are committed to delivering effective and
          practical solutions to even the most complex statutory compliance challenges. With a
          client base of over 2000+ organizations, our reach spans a wide range of industries,
          including:
        </p>

        <ul className="list-disc list-inside mb-4 pl-4 bullets">
          <li>Construction & Infrastructure</li>
          <li>Real Estate</li>
          <li>Corporate & Financial Institutions</li>
          <li>Textiles & Manufacturing</li>
          <li>IT & ITES</li>
          <li>Healthcare & Pharmaceuticals</li>
          <li>Security Services</li>
          <li>Restaurants & Hospitality</li>
          <li>Teaching & Training Institutions</li>
          <li>And many more...</li>
        </ul>

        <p className="mb-4">
          Our mission is to protect our clients from the risks and repercussions of non-compliance
          while ensuring timely and smooth execution of all statutory requirements.
        </p>

        <p className="mb-4">
          To further streamline compliance tracking, we offer <strong>Comply Trackers</strong> – our
          in-house online MIS portal, designed to simplify, monitor, and manage compliance tasks
          efficiently, offering real-time updates and clarity to our clients.
        </p>

        <p>
          At <strong>Bhatt & Karle Associates</strong>, we believe in providing prompt, quality
          service at value-driven prices, ensuring our clients experience both peace of mind and
          regulatory confidence.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
